import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

// --------------------------------------------------------------------------- //
// Réglages globaux (table app_settings) — édités depuis l'admin, lus côté back/.
// --------------------------------------------------------------------------- //
export interface AppSetting {
  key: string;
  value_int: number | null;
  description?: string | null;
  updated_at?: string | null;
  updated_by?: string | null;
}

export interface AppSettingsResponse {
  settings: AppSetting[];
}

export async function getAppSettings(
  navigate: NavigateFunction
): Promise<AppSettingsResponse> {
  const res = await apiFetch(`${API_URL}/admin/app-settings`, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des réglages");
  return res.json();
}

export async function updateAppSetting(
  key: string,
  payload: { value_int: number },
  navigate: NavigateFunction
): Promise<AppSetting> {
  const res = await apiFetch(
    `${API_URL}/admin/app-settings/${encodeURIComponent(key)}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
    navigate
  );
  if (!res?.ok) {
    const detail = await res?.json?.().catch(() => null);
    throw new Error(detail?.detail ?? "Erreur lors de la mise à jour du réglage");
  }
  return res.json();
}
